import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/common/layout";
import { _renderSection } from "../components/page/_renderSection.jsx";
import ContactUs from "../components/home/career";
import HomeHero from "../components/home/hero";
import Seo from "../components/common/seo.jsx";

const Page = ({ data: { sanityPage } }) => {
  return (
    <Layout>
      <HomeHero data={sanityPage.hero} />

      {sanityPage.pageBuilder.map((item, key) => {
        return _renderSection(item, key);
      })}
      {sanityPage.contactUs?.enable && (
        <ContactUs data={sanityPage.contactUs} />
      )}
    </Layout>
  );
};

export function Head({ location, data }) {
  return <Seo location={location} data={data?.sanityPage?.seo} />;
}

export const query = graphql`
  query ($slug: String!) {
    sanityPage(slug: { current: { eq: $slug } }) {
      seo {
        title
        description
        keywords
        ldSchema
      }
      hero {
        title
        description
        image {
          altText
          image {
            hotspot {
              x
              y
              width
              height
            }
            crop {
              top
              bottom
              left
              right
            }
            asset {
              _id
              gatsbyImageData(
                layout: FULL_WIDTH
                formats: WEBP
                placeholder: BLURRED
              )
              metadata {
                blurHash
              }
            }
          }
        }
        overlay
        enableButton: enable
        button {
          linkType
          buttonText
          sectionId
          slug {
            current
          }
          url
        }
      }
      pageBuilder {
        ... on SanityHeading {
          _type
          enable
          alignment
          title
          description
        }
        ... on SanityContentSection2 {
          _type
          enable
          sectionId
          caption
          title
          _rawDescription
          enableButton
          button {
            linkType
            buttonText
            sectionId
            slug {
              current
            }
            url
          }
          image {
            altText
            image {
              asset {
                gatsbyImageData(
                  layout: CONSTRAINED
                  formats: [WEBP, AUTO]
                  placeholder: BLURRED
                )
              }
            }
          }
          imageText
        }
        ... on SanityVideoContent {
          _type
          enable
          sectionId
          caption
          title
          _rawDescription
          videoFile {
            asset {
              url
            }
          }
          enableButton
          button {
            linkType
            buttonText
            sectionId
            slug {
              current
            }
            url
          }
        }
        ... on SanityAccordionSection {
          _type
          enable
          sectionId
          title
          description
          accordionItems {
            title
            overview
            _rawContent
          }
        }
        ... on SanityFaqsSection {
          _type
          enable
          heading
          faqs {
            question
            answer
          }
          button {
            linkType
            buttonText
            sectionId
            slug {
              current
            }
            url
          }
        }
        ... on SanityDescriptionSection {
          _type
          enable
          sectionId
          title
          _rawDescription
          enableButton
          button {
            linkType
            buttonText
            sectionId
            slug {
              current
            }
            url
          }
        }
        ... on SanityTableSection {
          _type
          enable
          sectionId
          title
          table {
            _key
            rows {
              _key
              cells
            }
          }
          enableButton
          button {
            linkType
            buttonText
            sectionId
            slug {
              current
            }
            url
          }
        }
        ... on SanityYoutube {
          _type
          title
          url
        }
        ... on SanityListingSection {
          _type
          enable
          caption
          title
          _rawDescription
          list {
            title
            description
            image {
              asset {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  formats: WEBP
                  placeholder: BLURRED
                )
              }
            }
          }
        }
        ... on SanityOurTeam {
          _type
          enable
          caption
          title
          _rawDescription
          team {
            name
            designation
            expertise
            profileImage {
              hotspot {
                x
                y
                width
                height
              }
              crop {
                top
                bottom
                left
                right
              }
              asset {
                _id
                gatsbyImageData(
                  layout: FULL_WIDTH
                  formats: WEBP
                  placeholder: BLURRED
                )
                metadata {
                  blurHash
                }
              }
            }
          }
        }
      }
      contactUs {
        enable
        sectionId
        caption
        contentSplit
        title
        _rawDescription
        image {
          altText
          image {
            asset {
              gatsbyImageData(
                layout: CONSTRAINED
                formats: WEBP
                placeholder: BLURRED
              )
            }
          }
        }
        enableButton
        button {
          linkType
          buttonText
          sectionId
          slug {
            current
          }
          url
        }
      }
    }
  }
`;

export default Page;
